/**
 * Hold long-polling intervals that call things regularly.
 *
 * Aka all setInterval() calls that we use to sync/check logic against
 * the backend should be bundled in here to avoid adding them in
 * different places and then losing the overview.
 */

const oneMinuteInMilliseconds = 1000 * 60;

export const longPollingRegistry = {
  everyMinute: oneMinuteInMilliseconds,
  every5Minutes: oneMinuteInMilliseconds * 15,
  every10Minutes: oneMinuteInMilliseconds * 10,
  every15Minutes: oneMinuteInMilliseconds * 15,
  everyHalfHour: oneMinuteInMilliseconds * 30,
  everyHour: oneMinuteInMilliseconds * 60,

  _funcNameToIntervalId: {},

  registerLongpollingCall: function (func, milliseconds) {
    this.unregisterLongpollingCall(func);

    const intervalId = setInterval(func, milliseconds);
    this._funcNameToIntervalId[func.name] = intervalId;
  },

  unregisterLongpollingCall: function (func) {
    const intervalId = this._funcNameToIntervalId[func.name];
    if (intervalId) {
      clearInterval(intervalId);
    }
    delete this._funcNameToIntervalId[func.name];
  },

  unregisterAllLongpollingCalls() {
    for (let funcName of Object.keys(this._funcNameToIntervalId)) {
      const intervalId = this._funcNameToIntervalId[funcName];
      if (intervalId) {
        clearInterval(intervalId);
      }
      delete this._funcNameToIntervalId[funcName];
    }
  },

  listAll() {
    return Object.keys(this._funcNameToIntervalId).map((funcName) => {
      return {
        funcName: funcName,
        intervalId: this._funcNameToIntervalId[funcName],
      };
    });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/longPollingRegistry.js